module.exports = __webpack_public_path__ + "img/robot.c024cf6e.png";